import styled from 'styled-components/macro';
import {Helmet} from "react-helmet";
import {useActions, useLoggedIn, useSettings} from "../store";
import {useBaseCommunity, useGoogleAdsEnabled, useStoreCommunity} from "../store/hooks";
import {useEffect, useState} from "react";
import useWindowDimensions from "../utils/dimensions";
import {useFeedback} from "../store/feedback";
import {useCommunities} from "../api/communities";
import {useTitleBrand} from "../utils/title";
import isStandardBaseCommunity from "../utils/base_community";
import useHost from "../utils/host";

const HeaderData = styled(({title, showBrand = true, community, description, image, children, ogImageUrlOverride = false}) => {

    const isStandardBase = isStandardBaseCommunity();

    const brand = useTitleBrand(community);

    const loggedIn = useLoggedIn();
    const {custom_styling} = useSettings();
    const loading = useFeedback();
    const loadCommunity = useCommunities(loading.channel, [community])[0] || false;
    const storeCommunity = useStoreCommunity(community);
    const baseCommunity = useBaseCommunity();

    const thirdPartyDefaultStyle = baseCommunity === "TheDonald" && community.toLowerCase() === "thedonald" ? "https://img.scored.co/thedonald/community/style-og5xDyJhWxGY.css" : "";
    const styleUrl = storeCommunity && storeCommunity.stylesheet && `https://img.scored.co/${community.toLowerCase()}/community/style-${storeCommunity.stylesheet}.css`;

    const metaTitle = title || brand;

    const compressedMedia = image?.resized_resolutions[0] || false;
    const contentType = compressedMedia?.["content-type"];
    const imageUrl = contentType ? (contentType !== 'mp4' && `https://media.scored.co${compressedMedia.reference}`) : false;
    const metaImage = imageUrl || "https://media.scored.co/post/daDIjFi8RBFT.png";

    const metaDescription = description?.length > 0 ? description : (storeCommunity?.description ? storeCommunity.description : (isStandardBase ? 'Scored is a network of user-created communities, ranging from memes and animals to politics and more. Join a community or create your own.'
    : "The Donald is a never-ending rally of patriots dedicated to the 45th President of the United States, Donald J. Trump."));

    const [width, setWidth] = useState(useWindowDimensions().width);

    const qualifiedUser = navigator.userAgent !== 'Mozilla/5.0 (Windows NT 10.0; rv:78.0) Gecko/20100101 Firefox/78.0';

    const isPatriots = baseCommunity === "TheDonald";

    const conditionIsMet = community === "abc124";
    const isScoredCo = useHost() === "scored.co" || useHost() === "communities.win";

    const actions = useActions();
    const googleAdsEnabled = useGoogleAdsEnabled();
    useEffect(() => {
        if (isScoredCo && conditionIsMet) {
            actions.googleAdsEnabledChanged(true);
        }
    }, [community]);

    return (
        <Helmet>
            <title>{`${title} ${showBrand ? `— ${brand}` : ''}`}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={storeCommunity?.meta_tags ? storeCommunity.meta_tags : (isStandardBase ? 'scored, alt tech, win, free speech, social media, anonymous, private, reddit, forum'
            : 'the donald, trump, forum, america, reddit, trump forum, donald trump, free speech, pepe, patriots win, patriotswin, patriots, the donald win, r/the_donald, the_donald, td, tdw, pdw')} />
            <meta itemProp="name" content={metaTitle} />
            <meta itemProp="description" content={metaDescription} />
            <meta itemProp="image" content={ogImageUrlOverride || metaImage} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={ogImageUrlOverride || metaImage} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={ogImageUrlOverride || metaImage} />
            <meta name="twitter:dnt" content="on" />
            {(styleUrl || thirdPartyDefaultStyle) && custom_styling && <link rel="stylesheet" href={styleUrl || thirdPartyDefaultStyle} type="text/css" media="all" />}
{/*            {googleAdsEnabled && <script src={"https://cdn.adligature.com/scored.co/prod/rules.js"} defer />}*/}
            {isScoredCo && <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5433240839183569" crossOrigin="anonymous" />}
            {children}
        </Helmet>
    );
})``;

export default HeaderData;
